"use client";

import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import { cn } from "@faire/react/tools/cn";
import { Close } from "@faire/slate-icons/Close";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { ButtonIcon } from "@faire/slate/private/button/ButtonIcon";
import { useHandleKeyDown } from "@faire/slate/private/hooks/useHandleKeyDown";
import React, { useRef } from "react";

type IProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: () => void;
};

export const ToastCloseButton: React.FC<React.PropsWithChildren<IProps>> = ({
  onClick,
  children,
  className,
  ...props
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { strictLocalize } = useStrictLocalization();

  useHandleKeyDown({
    Escape: () => onClick?.(),
  });

  return (
    <ButtonBase
      className={cn(
        "fs-icon-button",
        "fs-icon-button--primary",
        "fs-icon-button--xx-small",
        className
      )}
      onClick={onClick}
      aria-label={strictLocalize({
        id: "j/EWa/",
        defaultMessage: "Close notification",
        description: {
          text: "Screen reader label for a close button in a notification",
        },
      })}
      {...props}
      ref={buttonRef}
    >
      <ButtonIcon
        Icon={Close}
        titleAccess=""
        className="fs-icon-button__icon"
      />
    </ButtonBase>
  );
};
